import React, { useEffect } from "react";
import styles from "./products.module.scss";
import ProductsTileCard from "../../components/uiComponents/productsTileCard/ProductsTileCard";
import StatusCard from "../../components/uiComponents/statusCard/StatusCard";
import { connect, useDispatch } from "react-redux";
import { getAllCategory, getAllProduct } from "../../store/actions";
import product from "../../store/reducer/product";

const Products = ({products=[],categories=[]}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllProduct());
    dispatch(getAllCategory());
  }, []);

  const tileData = [
    {
      title: `Total - ${categories?.length}`,
      subTitle: "Categories",
    },
    {
      title: `Total - ${products?.length}`,
      subTitle: "Products",
    },
  ];
  return (
    <div className={styles.container}>
      <StatusCard
        leftContent="INVENTORY" // or any icon/component
      />
      <div className={styles.wrapper}>
        {tileData?.map((item) => (
          <ProductsTileCard title={item?.title} subTitle={item?.subTitle} />
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    products: state?.product?.products,
    categories: state?.category?.categories,
  };
};

export default connect(mapStateToProps, null)(Products);
